export default __webpack_public_path__ + "static/media/ppt.32bc8415.svg";